import React, { Fragment } from 'react';
import { useLocation } from 'react-router-dom';

const RedirectSSO = () => {
  const location = useLocation();
  const rootUrl = process.env.REACT_APP_PUBLIC_URL;
  const loginUrl = escape(`${rootUrl}/login`);
  const targetUrl = escape(location.state.prevPath) || '/';

  window.location.href = `https://www2.polyu.edu.hk/edc/authws/auth/index.php?loginUrl=${loginUrl}&targetUrl=${targetUrl}`;
  return <>Redirecting...</>;
};

export default RedirectSSO;
